exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#Header nav{margin-left:auto;margin-right:auto;color:#000;min-height:50px;max-width:1200px;font-family:comfortaa;z-index:1030}#Header .logo{float:left;height:35px}#Header .items{margin:1.5em;float:right;outline:none;font-size:12px;color:#000;text-decoration:none}#Header .items:actived,#Header .items:focus,#Header .items:hover{outline:none;color:#ff4d5a;text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a93e3cfc","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Header.vue
// module id = 215
// module chunks = 0